export default {
	home: 'Casa',
	contact: 'Contatto',
	aboutUs: 'Riguardo a noi',
	logout: 'Disconnettersi',
	login: 'Accesso',
	register: 'Iscriviti qui',
	search: 'Ricerca',
	login_fa: 'Fai il login con facebook',
	login_go: 'Accedi con Google',
	sign_in_man: 'Accedi manualmente',
	username: 'Nome utente',
	password: "Parola d'ordine",
	btn_register: 'Iscriviti ora',
	btn_lost_pass: 'Ha dimenticato la password?',
	text_remenber: 'Ricordati di me',
	check_in: 'Registrare',
	itfa_abr: 'INDEPENDENT TELEFOOTBALL ASSOCIATION',
	select_platform: 'Seleziona una piattaforma',
	about_us:
		'<p>In order to get as close to <strong>our way</strong> to run a competition as real as possible in FIFA would like to highlight some details about what your experience in this game.</p><p>Currently we have about 800+ players in our Pro Clubs & Groups 1v1 is soon to be held, where many are involved in one or other of the powers that are exclusive to PS4 due to various reasons.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 where you can demonstrate your ability.</p><p>– PRO CLUBS it is a mode of FIFA 16 online game where you can create a Virtual Pro player and play your own position in the field with your fellow realistically as you can live football online. The more games you play and unlock more feats, Virtual Pro unlock your best attributes and appearance options. Play casual games or join a club or create your own to get points with your own club.</p><p>You can also interact with us, MarDar photos from your club oh video, contact us, ask questions and send suggestions and comments on our way as we have the web and Administration page, ensuring to serve them and respond as soon as possible with a problem that have.</p><p><strong>A cordial greeting.</strong></p><p>We hope to meet your expectations with quality and satisfaction quickly because it is our true FIFA16 philosophy of work.</p>',
	text_contact:
		'<p>Thanks for your visit.</p><p>If you have any suggestions, complaints or comments please write, we will be happy to answer.</p>',
	subject: 'Soggetto',
	email: 'E-mail',
	name: 'Nome',
	message: 'Messaggio',
	messages: 'messaggi',
	required: 'Necessario',
	submit: 'Invia',
	return: 'Ritorno',
	pleaseWait: 'attendere prego...',
	registerTitle: 'Registrazione Utente',
	repeatPassword: 'Ripeti la tua password',
	country: 'Nazione',
	position: 'Posizione',
	console: 'Consolle',
	motto: 'Motto',
	selectOption: "Selezionare l'opzione",
	allRightsReserved: 'All rights reserved',
	profile: 'Profilo',
	myProfile: 'il mio profilo',
	friends: 'Amici',
	edit: 'modificare',
	editUser: 'Modifica le mie informazioni',
	language: 'linguaggio',
	save: 'Salva',
	changePassword: 'Cambia la password',
	currentPassword: 'Password attuale',
	newPassword: 'Nuova password',
	repeatNewPassword: 'Ripetere la nuova password',
	options: 'Opzioni',
	createAdmins: 'Create administrators',
	sliderPrimary: 'Slider primario',
	changeGt: 'Change gamertag',
	toPremium: 'Switch to premium',
	updatedData: 'Update data',
	tutorialCreate: 'Create tutorial',
	bets: 'Scommesse',
	textChangeImgSlider:
		'<li>The image should have no more weight than 2MB.</li><li>Minimum resolution 1366 x 598 pixels.</li><li>The only permitted extension is JPG.</li>',
	findImage: 'Image search',
	details: 'Details',
	updatedInfo: 'Informazioni aggiornate.',
	create: 'Creare',
	title: 'Titolo',
	delete: 'Elimina',
	error404: 'La risorsa non esiste.',
	enterUserId: "Inserisci l'id di un utente",
	cancel: 'Annulla',
	confirmTitleDelete: 'Conferma cancellazione',
	confirmTextDelete: "Si è sicuri di eliminare l'elemento selezionato ?",
	editInfoUser: 'Modifica le informazioni degli utenti',
	resetPassword: 'reimposta la tua password',
	enterYourEmail: 'Inserisci la tua email',
	myNews: 'Le mie notizie',
	image: 'Immagine',
	published: 'Pubblicata',
	modified: 'Modificata',
	comments: 'Bemerkungen',
	date: 'Data',
	time: 'Tempo',
	createdAgo: 'Creato fa',
	content: 'Soddisfare',
	cover: 'Copertina',
	show: 'Mostrare',
	enterIdOrUsername: 'Inserisci un ID giocatore o un nome utente',
	month: 'mese | mesi',
	year: 'anno | anni',
	selectPlatform: 'Seleziona una piattaforma',
	langEs: 'Spanish',
	langEn: 'English',
	langPt: 'Portuguese',
	description: 'Descrizione',
	videoCode: 'Codice video',
	order: 'Ordine',
	tournaments: 'tornei',
	tournament: 'Torneo',
	favorites: 'Preferiti',
	online: 'in linea',
	notices: 'notizia',
	readMore: 'Read more',
	seeAllNews: 'Vedi tutte le notizie',
	rankingPlayers: 'Classifiche dei giocatori',
	rankingTeams: "Posizionamento dell'attrezzatura",
	lastMatches: 'Ultime partite',
	round: 'tondo | giri',
	theBest: 'Il migliore',
	signings: 'signings',
	rules: 'Regole',
	divisions: 'divisioni',
	division: 'Divisione',
	teams: 'squadre',
	team: 'Squadra',
	transfers: 'trasferimenti',
	assistances: 'assistenze',
	scorer: 'Scorer | Marcatori',
	transferClose: '{time} lasciato fino alla chiusura',
	transferOpen: '{time} lasciato per aprire',
	goal: 'obiettivo | obiettivi',
	assistance: 'assistere | assist',
	goalkeeper: 'Portiere | Portieri',
	bestPlayer: 'Miglior giocatore',
	point: 'punto | punti',
	bestDefense: 'La migliore difesa',
	bestOffensive: 'La migliore offensiva',
	goalFavor: 'obiettivo a favore | obiettivi a favore',
	goalAgainst: 'gol contro | gol contro',
	player: 'Giocatore',
	players: 'Giocatori',
	ranking: 'classifica',
	status: 'Stato',
	price: 'Prezzo',
	purchasedBy: 'Acquistato da',
	availableMoney: 'Denaro disponibile',
	free: 'gratuito',
	signing: 'Firmato',
	playedGames: 'Partite giocate',
	yellowCard: 'cartellino giallo | cartellini gialli',
	redCard: 'cartellino rosso | cartellini rossi',
	joinTheMarket: 'Unisciti al mercato',
	joinTheMarketConfirm:
		"ASei sicuro di voler iscriverti all'elenco dei giocatori gratuiti nel torneo?",
	yes: 'sì',
	not: 'Non',
	notice: 'Avviso',
	contract: 'Contrarre',
	sellPlayers: 'Vendi i giocatori',
	pendingRounds: 'Round in sospeso',
	sellerPlayerConfirm: 'Sei sicuro di voler vendere al giocatore selezionato?',
	table: 'tavolo',
	card: 'carta | carte',
	teamWeek: 'Squadra della settimana',
	nextMatches: 'Prossime partite',
	results: 'risultati',
	privateMsgFor: 'Messaggio privato per {user}',
	pj: 'G',
	pg: 'V',
	pe: 'P',
	pp: 'l',
	gf: 'GF',
	gc: 'GS',
	dg: 'DR',
	seeDT: 'Vedi manager',
	matches: 'fiammiferi',
	quantity: 'Quantità',
	training: 'Formazione',
	defense: 'difese',
	midfielders: 'centrocampisti',
	front: 'Davanti',
	award: 'premio | premi',
	champion: 'CAMPIONE',
	stats: 'statistica',
	type: 'genere',
	record: 'Disco',
	changeImage: 'Cambia immagine',
	addTeam: 'Aggiungi squadra',
	textFindNotice: 'Immettere una o più lettere e quindi premere INVIO',
	sendInvitation: 'Spedire un invito',
	createTournament: 'Crea torneo',
	editTournament: 'Modifica torneo',
	mode: 'modalità',
	category: 'categoria | categorie',
	hideTournament: 'Nascondi torneo?',
	deleteAllPlayersOfTeam:
		'Sei sicuro di eliminare tutti i giocatori della squadra selezionata?',
	handOutMoney: 'Distribuire soldi',
	add: 'Inserisci',
	remove: 'Rimuovere',
	transfersClosed: 'Trasferimenti: è chiuso',
	transfersOpened: 'Trasferimento: è aperto',
	transfersClosedMsg:
		'Il trasferimento è chiuso, i giocatori che sono stati invitati potranno entrare nella squadra.',
	transfersOpenedMsg:
		'Il trasferimento è aperto, i giocatori che sono stati invitati e non hanno accettato non possono entrare nella squadra fino alla prossima firma.',
	open: 'Aperto',
	close: 'Vicina',
	customButtons: 'Pulsanti personalizzati',
	label: 'Etichetta',
	showIn: 'Mostrare',
	selfLink: 'Nella stessa pagina',
	blankLink: "In un'altra pagina",
	views: 'Visualizzazioni',
	administrator: 'amministratore | amministratori',
	enterPlayerNick: 'Inserisci il soprannome di un giocatore',
	user: 'utente',
	roundsFinalPhase: 'ROUNDS casa / fuori casa',
	allFinalPhase: 'TUTTO CONTRO TUTTO / 1 gioco',
	manualDirectDisposal: 'SMALTIMENTO DIRETTO MANUALE',
	autoDirectDisposal: 'SMALTIMENTO DIRETTO AUTOMATICO',
	numberTeamsDown: 'Numero di squadre che sono in calo',
	numberTeamsPassLiguilla: 'Numero di squadre che passano ala liguilla',
	season: 'stagione | le stagioni',
	deliverCup: 'Consegna tazza',
	removeCup: 'RIMUOVERE LA TAZZA',
	toStart: 'INIZIARE',
	programming: 'PROGRAMMAZIONE',
	inProgress: 'IN CORSO',
	finished: 'FINITO',
	played: 'GIOCATO',
	notPresented: 'VINTO DA DEFAULT',
	changeDatesRounds: 'Cambia round di date',
	addPlayTime: 'Aggiungi tempo di gioco',
	selectDays: 'Seleziona uno o più giorni della settimana',
	monday: 'Lunedi',
	tuesday: 'martedì',
	wednesday: 'mercoledì',
	thursday: 'giovedi',
	friday: 'Venerdì',
	saturday: 'Sabato',
	sunday: 'Domenica',
	schedule: 'Programma del gioco',
	transferDate: 'Data di trasferimento',
	dateNextSigning: 'Data della prossima firma',
	endDate: 'Scadenza',
	choose: 'Scegliere',
	alternate: 'Alternato',
	showFixture: 'Mostra apparecchio',
	msgCreateFixture:
		'Dopo aver creato il dispositivo non è più possibile aggiungere più attrezzature al torneo. Sicuro di continuare?',
	createFixture: 'Crea apparecchio',
	btnIfContinue: 'Se voglio continuare',
	createLiguilla: 'Crea liguilla',
	thirdPlace: 'Terzo posto',
	myClub: 'Il mio club',
	myTeams: 'Le mie squadre',
	myGames: 'I miei giochi',
	management: 'Gestione',
	tshirts: 'magliette',
	notification: 'notifica | notifiche',
	from: 'A partire dal',
	detailsNotification: 'Notifica dei dettagli',
	invitation: 'invito | inviti',
	accept: 'Accettare',
	deny: 'Negare',
	invitationAccepted: 'Invito accettato.',
	invitationRejected: 'Invito rifiutato.',
	transferPlayer: 'Trasferisci giocatore',
	freePlayerPremium: 'Vuoi rilasciare il giocatore selezionato?',
	trainingShow: 'Allenarsi per mostrare',
	teamFormation: 'Formazione della squadra',
	myFormation: 'La mia formazione',
	invitePlayers: 'Giocatori invitati',
	myFavouriteTeams: 'Le mie squadre preferite',
	myFavouriteTournaments: 'I miei tornei preferiti',
	visitor: 'Visitatore',
	watchMatch: 'Guarda la partita',
	editVideos: 'Modifica video',
	addPictures: 'Aggiungi foto',
	toUpdate: 'Aggiornare',
	editMatch: 'Modifica i risultati della partita',
	participated: 'Aderire',
	none: 'Nessuna',
	changeResultMatch: 'Cambia i risultati di una partita',
	changeResults: 'Cambia i risultati',
	changeStatistics: 'Cambia le statistiche',
	enabledStatistics: 'Abilita la modifica delle statistiche',
	all: 'Tutti',
	coins: 'Monete',
	duration: 'Durata',
	toBuy: 'Comprare',
	relatedProducts: 'Prodotti correlati',
	purchasedProducts: 'Prodotti acquistati',
	boughtOn: 'Acquistato',
	beatOn: 'Battere su',
	use: 'USO',
	addCategory: 'Aggiungi categoria',
	bgTournaments: 'Immagine di sfondo per i tornei',
	bgDivisions: 'Immagine di sfondo per le divisioni',
	bgTeams: 'Immagine di sfondo per i team',
	bgPlayers: 'Immagine di sfondo per i giocatori',
	editCategory: 'Modifica categoria',
	addSubcategory: 'Aggiungi sottocategoria',
	editSubcategory: 'Modifier la sous-catégorie',
	createProduct: 'Crea un prodotto',
	visible: 'Visibile',
	editProduct: 'Modifica prodotto',
	cardNumber: 'Numero di carta',
	expirationDate: 'Data di scadenza',
	matchBetting: 'Scommesse sulla partita',
	matchWin: 'Partita vinta',
	bet: 'Scommessa',
	gain: 'Guadagno',
	matchesBet: 'Partite con scommessa',
	entry: 'Iscrizione',
	betMsgEntry:
		'Deducerà (<strong>{coin}</strong>) delle tue monete per giocare a questo gioco',
	confirmResults: 'Conferma i risultati',
	whatLokingFor: '¿Che cosa sta cercando?',
	textFind: 'Inserisci 3 lettere o caratteri',
	searchResults: 'Risultati della tua ricerca',
	seeCard: 'Vedi la scheda',
	only15Letters: 'Solo 15 caratteri.',
	rename: 'Rinominare',
	sendLinkResetPassword: 'E-mail cambia password',
	end: 'FINE',
	deliverPrizes: 'Consegna dei premi',
	confirm: 'Confermare',
	awardsConfirmText:
		'Sei sicuro di continuare? <br />Questa opzione non può essere annullata.',
	donateTitle: 'Apprezziamo il supporto fornito',
	donateThanks: 'Grazie per il vostro sostegno.',
	donateText:
		"<p>l'organizzazione ITFA ringrazia tutte le persone che, in un modo o nell'altro, apprezzano il duro lavoro svolto dall'amministrazione di questa pagina in cui sono organizzati tornei multipli di grande fama e alta competitività.</p><p>A tutti questi sponsor che si esibiscono in modo anonimo.</p><p>Siamo grati per il contributo, poiché ci motivano a continuare con questo grande progetto migliorando la pagina e mantenendola.</p>",
	donate: 'donare | donazioni',
	amountToDonate: 'Importo da donare',
	premiumForMonth:
		'Prezzo valido per 1 mese | Prezzo valido per 1 {month} mese',
	priceForMonth: '1 mese | {month} mesi',
	movements: 'movimenti',
	transferIn: '{player} è ora a {team} giocatore',
	transferOut: '{player} lasciato il club {team}',
	changeCup: 'Cambia tazza',
	banned: 'Baneados',
	reason: 'Ragione',
	bannedStart: 'Iniziato',
	bannedEnd: 'Bagnato',
	countries: 'Paesi',
	change: 'Modificare',
}
